import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaBancosPagosCargamultipleDecoderComponent {
  constructor () {
    this.error = false
    this.referencia = ''
  }

  decodificar () {
    try {
     let decoded = this.data.split('\n')
        .map((item) => {
          let data = item.split(' ')
          let Importe = parseFloat(data[2].replace(/[^0-9.]/g, ''))
          let Nombre = data.splice(3, data.length - 6).join(' ')

          return {Nombre, Importe}
        })

      this.error = false
      this.data = undefined

      this.onDecode({
        $event: {
          lista: decoded,
          referencia: this.referencia,
        },
      })
    } catch (error) {
      this.error = true
    }
  }
}

module.component('nominasNominaBancosPagosCargamultipleDecoder', {
  controller: NominasNominaBancosPagosCargamultipleDecoderComponent,
  template,
  bindings: {
    data: '<',
    onDecode: '&',
    onCerrar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/cargamultiple/decoder/component.js